<template>
  <div class="config-modal">
   
    <div class="config-head">
      <img class="user-headImg" v-if="avatar" :src="avatar" />
      <!-- <el-upload
        class="avatar-uploader"
        action=""
        :show-file-list="false"
        :on-change="handleChange"
        :auto-upload="false"
      > -->
      <div class="file-btn" @click="headDialogVisible = true">
        <span style="margin-right: 8px"> 修改头像 </span>
        <img src="@/assets/list/arrows-right.png" alt="" />
      </div>
      <!-- </el-upload> -->
    </div>
    <div class="config-main">
      <div class="main-title">基本资料</div>
      <el-form
        label-position="left"
        label-width="80px"
        :model="userInfo"
        :rules="rules"
      >
        <el-form-item label="编号">
          <el-input v-model="userInfo.extraProperties.UserCode"></el-input>
        </el-form-item>
        <el-form-item label="登录名">
          <el-input v-model="userInfo.userName"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="userInfo.name"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <!-- <el-input v-model="userInfo.type"></el-input> -->
          <el-radio v-model="userInfo.extraProperties.Sex" label="male"
            >男</el-radio
          >
          <el-radio v-model="userInfo.extraProperties.Sex" label="female"
            >女</el-radio
          >
        </el-form-item>
        <el-form-item label="手机">
          <!-- prop="phone" -->
          <el-input v-model="userInfo.extraProperties.MobilePhone"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="userInfo.email"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            style="width: 157px; height: 40px"
            type="primary"
            round
            :loading="loading"
            @click="onSubmit"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Api from "@/api/user";
let validatePhone = (rule, value, callback) => {
  /*console.log(rule);
      console.log(value);
      console.log(callback);*/
  if (!value) {
    callback(new Error("手机号不能为空！"));
  }
  //使用正则表达式进行验证手机号码
  if (!/^1[3456789]\d{9}$/.test(value)) {
    callback(new Error("手机号不正确！"));
  }
};
export default {
  props: {
    avatar: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      headDialogVisible: false,
      rules: {
        phone: [{ validator: validatePhone, trigger: "blur" }],
      },
    };
  },
  methods: {
 
    onSubmit() {
      this.loading = true;
      console.log("submit!");
      let params = {
        userName: this.userInfo.userName,
        name: this.userInfo.name,
        email: this.userInfo.email,
        mobilephone: this.userInfo.extraProperties.MobilePhone,
        sex: this.userInfo.extraProperties.Sex,
      };
      Api.updateUserInfo(this.userInfo.id, params)
        .then((res) => {
          console.warn(res);
          this.getUserInfo();
          this.loading = false;
        })
        .catch((err) => {});
      this.loading = false;
    },
    getUserInfo() {
      Api.getUserInfo(this.userInfo.id)
        .then((result) => {
          sessionStorage.setItem("userInfo", JSON.stringify(result.data));
          this.userInfo = result.data;
          // this.$success('上传成功');
        })
        .catch((err) => {
          console.warn(err);
        });
    },
  },
  created() {
    if (sessionStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    } else {
      this.getUserInfo();
    }
  },
};
</script>

<style lang="scss" scoped>
.config-modal {
  padding: 30px 50px;
  .config-head {
    display: flex;
    flex-direction: column;
    align-items: center;
    .file-btn {
      width: 101px;
      height: 34px;
      cursor: pointer;
      margin: 12px auto;
      background-color: #fdfefe;
      border: 0.8px solid #979797;
      font-size: 12px;
      font-weight: 600;
      color: #000000;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .user-headImg {
      width: 130px;
      height: 130px;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  .config-main {
    .main-title {
      font-size: 20px;
      font-weight: 600;
      text-align: left;
      color: #000000;
      line-height: 28px;
      margin-bottom: 15px;
    }
  }
}
</style>